import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { AgGrid, filters } from '../AgGrid';
import classnames from 'classnames';
import { formatNumberWithCommas } from '../../helpers';

const styles = theme => ({});

export const ClientAccountingHistoryDetail = withStyles(styles)(props => {
  const { gridData } = props;

  const columnDefs = [
    {
      headerName: 'Order Line ID',
      field: 'orderlineId',
    },
    {
      headerName: 'Order Line Total',
      field: 'orderLineTotal',
      filter: filters.number,
      valueFormatter: ({ value }) => {
        return `${formatNumberWithCommas(value, 2)}`;
      },
    },
  ];
  const gridOptions = {
    // columnDefs: mainColumnDefinitions,
  };

  return (
    <div
      className={classnames(
        // 'flex-1',
        'col-center-center',
      )}
      style={{
        position: 'relative',
        height: 400,
        padding: 30,
        justifyContent: 'flex-start',
      }}
    >
      <AgGrid
        gridData={gridData}
        columnDefs={columnDefs}
        gridOptions={gridOptions}
        sideBar={false}
        floatingFilter={false}
        redirectOnClick={false}
        editOnClick={false}
      />
    </div>
  );
});

ClientAccountingHistoryDetail.propTypes = {
  classes: PropTypes.object,
  gridData: PropTypes.array,
  // gridOptions: PropTypes.object.isRequired,
  onSave: PropTypes.func,
};
